module.exports = __webpack_public_path__ + "1fd7f1531096b8051abdd8b3244e155a.svg";